import Input from "@/components/frontend/ui/form/inputs/input";
import { type FormEmailBlock as FormEmailBlockT } from "@/payload-types";

type FormEmailBlockProps = FormEmailBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormEmailBlock: React.FC<FormEmailBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	return (
		<Input
			name={fieldName}
			type="email"
			value={typeof fieldValue === "string" ? fieldValue : ""}
			onChange={(event) => onFieldChange?.(event.target.value)}
			onBlur={onFieldBlur}
			autoComplete={settings?.autocomplete ?? undefined}
			placeholder={content.placeholder}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
		/>
	);
};
